var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMenuAdmins(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14989_4831)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 19.5V23.25",
    stroke: "#313335",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 3.375C19.5 1.92525 16.1422 0.75 12 0.75C7.85775 0.75 4.5 1.92525 4.5 3.375C4.5 4.143 5.448 4.8315 6.9495 5.3115C7.56975 6.57375 9.59325 7.5 12 7.5C14.4068 7.5 16.4302 6.57375 17.0505 5.3115C18.552 4.8315 19.5 4.143 19.5 3.375Z",
    stroke: "#313335",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.61425 14.3125L3.06375 17.8975C2.5905 18.1556 2.19553 18.5364 1.92036 18.9999C1.64518 19.4634 1.49997 19.9925 1.5 20.5315V23.2502H22.5V20.5315C22.5 19.9925 22.3548 19.4634 22.0796 18.9999C21.8045 18.5364 21.4095 18.1556 20.9363 17.8975L14.3857 14.3125",
    stroke: "#313335",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 4.94531V6.74981C18 11.2498 15.3135 14.9998 12 14.9998C8.6865 14.9998 6 11.2498 6 6.74981V4.94531",
    stroke: "#313335",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 5.25C12.6213 5.25 13.125 4.74632 13.125 4.125C13.125 3.50368 12.6213 3 12 3C11.3787 3 10.875 3.50368 10.875 4.125C10.875 4.74632 11.3787 5.25 12 5.25Z",
    fill: "#313335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14989_4831"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuAdmins);
export default __webpack_public_path__ + "static/media/icon_menu_admins.958e59ad.svg";
export { ForwardRef as ReactComponent };